"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Analytics_1 = tslib_1.__importDefault(require("../Analytics"));
var ErrorTracking = /** @class */ (function () {
    /**
     * Set up the tracking of errors (e.g. JS errors, image loading issues, etc.)
     * See README.md for code to add to the HTML "head" tag.
     */
    function ErrorTracking(analytics) {
        var _this = this;
        this.analytics = analytics;
        this.onReady = function () {
            // Replay any stored error events during load and remove listener
            if (window.__analyticsTrackError !== undefined) {
                var loadErrorEvents = window.__analyticsTrackError && window.__analyticsTrackError.q || [];
                for (var i = 0; i < loadErrorEvents.length; i++) {
                    _this.onWindowError(loadErrorEvents[i]);
                }
                window.removeEventListener("error", window.__analyticsTrackError, true);
                window.__analyticsTrackError = undefined;
            }
            // Add a new listener to track error events
            // Note are using "capture" by setting the last argument to "true". This is on purpose! Otherwise we won't get reports of image load errors and the like.
            window.addEventListener("error", _this.onWindowError, true);
        };
        this.onWindowError = function (errorEvent) {
            var actionCategory = errorEvent instanceof ErrorEvent ? "Error: ErrorEvent" : "Error: Event";
            var target = errorEvent.target;
            if (target instanceof HTMLImageElement && target.src.indexOf("bat.bing.com") !== -1) {
                // TODO Consider changing logic to the inverse and to on report if the domain is part of the list.... Maybe.
                //  Catching errors of external code would be good, it is just that MS seems to return data that is not not always an image.
                return;
            }
            _this.analytics.getLogger().debug("Error object being reported: ", errorEvent);
            var actionName = [];
            // Filename and location in file
            if (errorEvent.filename !== undefined) {
                var location_1 = errorEvent.filename;
                if (errorEvent.lineno !== undefined) {
                    location_1 += ":" + errorEvent.lineno;
                    if (errorEvent.colno !== undefined) {
                        location_1 += ":" + errorEvent.colno;
                    }
                }
                actionName.push(location_1);
            }
            if (target !== undefined && target !== null) {
                // Tag/Node Name
                if (target instanceof Node) {
                    actionName.push("Target: " + target.nodeName);
                }
                // Key element property
                if (target instanceof HTMLScriptElement) {
                    actionName.push("HTMLScriptElement.src: " + target.src);
                }
                else if (target instanceof HTMLImageElement) {
                    actionName.push("HTMLImageElement.src: " + target.src);
                }
                else if (target instanceof HTMLVideoElement) {
                    actionName.push("HTMLVideoElement.src: " + target.src);
                }
                else if (target instanceof HTMLFormElement) {
                    actionName.push("HTMLFormElement.action: " + target.action);
                }
                else if (target instanceof HTMLLinkElement) {
                    actionName.push("HTMLLinkElement.href: " + target.href);
                }
            }
            // Track the info
            /* TODO: Switch this to the recommended method of tracking approach.
                    https://developers.google.com/analytics/devguides/collection/gtagjs/exceptions
                    https://developers.google.com/analytics/devguides/collection/ga4/exceptions
                I think we create an interface (similar to BasicEventTracker) but for exception tracking.
            */
            /* TODO: There are sometimes no details. Look in GA that has used this code and figure out
                    which browser and how to et details added.
            */
            var actionLabel = (errorEvent.error && errorEvent.error.stack) || errorEvent.message || Analytics_1.default.emptyValue;
            _this.analytics.trackEvent(actionCategory, actionName, actionLabel, 0, true // nonInteraction
            );
        };
        if (document.readyState === "interactive" || document.readyState === "complete") {
            this.onReady();
        }
        else {
            window.addEventListener("DOMContentLoaded", this.onReady);
        }
    }
    return ErrorTracking;
}());
exports.default = ErrorTracking;
